import { ReactNode } from "react";
import { SpanToggle } from "../navbar/shopping-card-item";
export interface ISpanToggle {
  children?: ReactNode;
  className: string;

}
function DropdownspanToggle({ children, className }: ISpanToggle) {
  return (
    <button id="number" type="button" className={className}>
      <SpanToggle onClick={()=>{}}>{children}</SpanToggle>
    </button>
  );
}

export default DropdownspanToggle;
